import { Component, OnInit } from '@angular/core';
import {
    fbxService
} from 'src/app/services';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
    public loadingComplete: boolean = false;
    public removeLoader: boolean = false;

    constructor(private fbxSvc: fbxService) { }

    ngOnInit(): void {
        this.subscribe();
    }
    public subscribe(): void {
        this.fbxSvc.modelsLoaded.subscribe(data => {
            console.log(': modelsLoaded: ', data);
            this.loadingComplete = data;
            if (data) {
                setTimeout(() => {
                    this.removeLoader = true;
                }, 500);
            }
        });
    }
}
